import { render } from "./NewPasswordPage.vue?vue&type=template&id=5ac94d4e"
import script from "./NewPasswordPage.vue?vue&type=script&lang=js"
export * from "./NewPasswordPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__